import axios from '../utils/axios';

class DatabaseNotificationService {
  constructor() {
    const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
    this.baseURL = `${API_BASE_URL}/notifications`;
  }

  // Get auth token
  getToken() {
    return localStorage.getItem('token') ||
      localStorage.getItem('companyToken') ||
      localStorage.getItem('employeeToken');
  }

  // Get all notifications
  async getNotifications(unreadOnly = false) {
    try {
      const token = this.getToken();
      const response = await axios.get(this.baseURL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { unreadOnly: unreadOnly ? 'true' : 'false' }
      });

      return response.data;
    } catch (error) {
      console.error('❌ Error fetching notifications:', error);
      throw error;
    }
  }

  // Get unread notifications only
  async getUnreadNotifications() {
    return this.getNotifications(true);
  }

  // Mark notification as read
  async markAsRead(notificationId) {
    try {
      const token = this.getToken();
      const response = await axios.patch(
        `${this.baseURL}/${notificationId}/read`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error marking notification as read:', error);
      throw error;
    }
  }

  // Mark all notifications as read
  async markAllAsRead() {
    try {
      const token = this.getToken();
      const response = await axios.patch(
        `${this.baseURL}/mark-all-read`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error marking all notifications as read:', error);
      throw error;
    }
  }

  // Delete notification
  async deleteNotification(notificationId) {
    try {
      const token = this.getToken();
      const response = await axios.delete(
        `${this.baseURL}/${notificationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error deleting notification:', error);
      throw error;
    }
  }

  // Create notification (for testing or admin use)
  async createNotification(notificationData) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        this.baseURL,
        notificationData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data;
    } catch (error) {
      console.error('❌ Error creating notification:', error);
      throw error;
    }
  }
}

export default new DatabaseNotificationService();
